export default "__VITE_ASSET__DPTcMh1$__"